import { render, staticRenderFns } from "./ClosingReport.vue?vue&type=template&id=004b8e54&scoped=true&"
import script from "./ClosingReport.vue?vue&type=script&lang=js&"
export * from "./ClosingReport.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReport.vue?vue&type=style&index=0&id=004b8e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b8e54",
  null
  
)

export default component.exports